<template>
  <div class="accordion">
    <transition :name="isWithoutTransition ? '' : 'content'">
      <div class="accordion-content" v-if="isVisible">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'SbAccordion',
  props: {
    isVisible: {
      type: Boolean,
      default: false,
      required: true
    },
    isWithoutTransition: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">

.accordion {
  overflow: hidden;

  .content-enter,
  .content-leave-to {
    max-height: 0;
  }

  .content-enter-active,
  .content-leave-active {
    transition: height, 0.5s linear;
  }

  .content-leave,
  .content-enter-to {
    max-height: 1200px;
  }
}

@media screen and (max-width: 1200px) {
  .accordion {
    margin-right: 0;
  }
}

</style>